<template>
  <span :class="['tag is-rounded is-medium', statusConfig.theme]">
    <template v-if="props.status === 'verifying'">
      {{ statusConfig.text }}<loading-ellipsis />
    </template>
    <template v-else>
      <span class="icon">
        <i :class="['fa', statusConfig.icon]"/>
      </span>
      <span>{{ statusConfig.text }}</span>
    </template>
  </span>
</template>

<script setup lang="ts">
import LoadingEllipsis from '@/components/common/LoadingEllipsis.vue';
import useI18n from "@/locales/useI18n"
import { computed } from "vue"
import { defineProps } from "vue"
import { AddressStatus } from '@/interfaces/admin/places'
const { t } = useI18n()

type Props = {
  status: AddressStatus | string | null
}

const props = defineProps<Props>()

const normalizedStatus = computed(() => {
  // Map AddressStatus enum values to display states
  if (props.status === AddressStatus.VERIFIED) return 'verified'
  if (props.status === AddressStatus.UNVERIFIED) return 'unverified'
  if (props.status === AddressStatus.ADD_SUBPREMISE) return 'unverified' // Treat as unverified
  return 'undefined'
})

const statusConfig = computed(() => {
  const config = {
    verifying: {
      icon: "",
      text: t("verifying"),
      theme: "is-light"
    },
    verified: {
      icon: "fa-check",
      text: t("verified"),
      theme: "is-success"
    },
    unverified: {
      icon: "fa-exclamation-triangle",
      text: t("unverified"),
      theme: "is-warning"
    },
    undefined: { icon: "", text: "", theme: "" }
  }
  return config[normalizedStatus.value]
})
</script>

<style scoped lang="scss">
.tag {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
}
</style>
